<template>
    <div id="app" class="col-md-6 offset-md-3 col-sm-12 h-100 p-3">
        <Recaptcha v-if="!acessoValido" />

        <ErroCarregar v-else-if="erro !== false || !atendimentoEncontrado" />        

        <Loader v-else-if="!apiLoaded && atendimentoEncontrado" />
        
        <Expirado v-else-if="expirado === 'S'" />

        <div v-else-if="atendimentoEncontrado">
            <router-view/>
        </div>
    </div>
</template>

<script>
import Recaptcha from "@/components/Recaptcha.vue";
import ErroCarregar from "@/components/ErroCarregar.vue";
import Loader from "@/components/Loadings/Loader.vue";
import Expirado from "@/components/Expirado.vue";
import { googleKeyEnv } from "@/assets/js/googleMapsScript.js";
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';


export default {
    name: "App",
    data() {
        return {
            acessoValido: false,
            atendimentoEncontrado: true,
        }
    },
    components: {
        Recaptcha,
        ErroCarregar,
        Loader,
        Expirado,
    },
    computed:{
        ...mapGetters('Atendimento', {
            atendimento: 'dadosAtendimento',
            expirado: 'expirado',
            servicos: 'servicos',
        }),
        ...mapState('Atendimento', {
            erro: 'erro',
            apiLoaded: 'apiLoaded',
            coordenadas: 'coordenadasAtendimento'
        }),
        ...mapMutations('Atendimento', {
            setApiLoaded: 'setApiLoaded'
        }),
    },
    sockets: {
        connect: function () {
            console.info('socket connected');
        },
        disconnect: function () {
            console.info('socket disconnected');
        },
        atualizarAtendimento(param) {
            this.buscarDadosAtendimento({idAtendimento: param.idAtendimento, atualizar: true});

            if (navigator.userAgent.toLowerCase().indexOf("iphone") <= -1) {
                const notificacao = this.$func.notifyDesktop({
                    body: 'Houve uma atualização no atendimento.',
                    title: "Link solicitante",                
                    vibrate: [200, 100, 200, 100, 200, 100, 200],
                    tag: "atualizarAtendimento#" + param.idAtendimento,
                    icon:  require("@/assets/img/link_solicitante.png"),
                    badge:  require("@/assets/img/link_solicitante.png")
                });
                if (notificacao != null) {
                    notificacao.onclick = function () {
                        window.focus();
                    };
                }
            } else {
                this.$toast("Houve uma atualização no atendimento.", {
                    timeout: 5000
                });
            }
        },
    },
    methods: {
        ...mapActions('Atendimento', ['buscarDadosAtendimento']),
        iniciarLink() {          
            if (this.$func.isEmpty(this.$route.params.idAtendimento) && !this.$func.isEmpty(localStorage['ultimoAtendimentoAcessado'])) {
                this.$router.replace({ path: `/${localStorage['ultimoAtendimentoAcessado']}` });
            }

            if (!this.$func.isEmpty(this.$route.params.idAtendimento)) {
                localStorage['ultimoAtendimentoAcessado'] = this.$route.params.idAtendimento;
                this.buscarDadosAtendimento({idAtendimento: this.$route.params.idAtendimento, atualizar: false});
                this.$socket.io.opts.query.idAtendimento = this.$route.params.idAtendimento;
                this.$socket.connect();  
            } else {
                this.atendimentoEncontrado = false;
            }
        }
    },
    created() {
        if (process.env.NODE_ENV == 'development') {
            this.acessoValido = true;
            localStorage['acessoValido' + this.$route.params.idAtendimento] = true;
        }
        
        if (!this.$func.isEmpty(localStorage['acessoValido' + this.$route.params.idAtendimento])) {
            this.acessoValido = JSON.parse(localStorage['acessoValido' + this.$route.params.idAtendimento]);
        }

        if (this.acessoValido) {
            this.iniciarLink();
        }
    },
    mounted() {
        const googleKey = googleKeyEnv[process.env.NODE_ENV || "development"].GOOGLE_KEY;

        const sourceMapsApi = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&callback=Function.prototype`;

        const tag = document.querySelector(`script[src="${sourceMapsApi}"]`);

        if (!tag) {
            const script = document.createElement('script');
            script.src = sourceMapsApi;
            script.async = true;
            script.defer = true;

            document.body.appendChild(script);
        }
    },
}
</script>
